import { addEventListener } from "@oddcamp/js-utils/src/event"
import { addClass, toggleClass } from "@oddcamp/js-utils/src/attribute"
import throttle from "raf-throttle"

import init from "../../shared/utils/init"

// bookmarking

init(() => {
  const buttons = document.querySelectorAll(`.js--mission-page-bookmark`)
  if (!buttons) return

  const disableButtons = () => buttons.forEach((b) => (b.disabled = true))
  const enableButtons = () => buttons.forEach((b) => (b.disabled = false))

  const displayOnlyButtons = (method) => {
    addClass(buttons, `is-hidden`)
    buttons.forEach(
      (b) => b.dataset.method == method && b.classList.remove(`is-hidden`)
    )
  }

  addEventListener(buttons, `ajax:before`, (e, buttonEl) => {
    disableButtons()
    displayOnlyButtons(buttonEl.dataset.method == `post` ? `delete` : `post`)
  })

  addEventListener(buttons, `ajax:complete`, enableButtons)
  addEventListener(buttons, `ajax:error`, (e, buttonEl) =>
    toggleClass(buttons, `is-hidden`)
  )
})

// sticky

init(() => {
  const el = document.querySelector(`.vb-mission-page-sticky`)
  const refEl = document.querySelector(`.vb-mission-page__content .-actions`)
  if (!el || !refEl) return

  const navbarEl = document.querySelector(`.vb-nav`)
  const navbarHeight = navbarEl ? navbarEl.clientHeight : 0

  window.addEventListener(
    `scroll`,
    throttle(() => {
      const shouldBeSeen = refEl.getBoundingClientRect().top < 0
      el.classList.toggle(`--active`, shouldBeSeen)

      if (shouldBeSeen) {
        el.style.transform = `translateY(${navbarHeight}px)`
      } else {
        el.style.transform = ``
      }
    })
  )
})

// tags collapse/expand

init(() => {
  const maxHeightTagsEl = document.querySelector(
    `.vb-mission-page__tags.-max-h, .vb-web-mission-page__tags.-max-h`
  )
  const maxHeightBtnEl = document.querySelector(
    `.vb-mission-page__show-more, .vb-web-mission-page__show-more`
  )
  if (!maxHeightTagsEl || !maxHeightBtnEl) return

  maxHeightBtnEl.addEventListener(`click`, () => {
    const isToggled =
      maxHeightBtnEl.querySelector(`span`).textContent === `Visa färre`

    maxHeightTagsEl.style.maxHeight = isToggled
      ? ``
      : maxHeightTagsEl.scrollHeight + `px`

    maxHeightBtnEl.querySelector(`span`).textContent = isToggled
      ? `Visa fler`
      : `Visa färre`

    maxHeightBtnEl.classList.toggle(`-active`)
  })
})
